/* eslint-disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{
  "rawString": ".root_de478240{display:inline-block;vertical-align:middle;speak:none;width:1em;height:1em}.svg_de478240{height:100%;fill:currentColor;vertical-align:top}"
}]);
export var root = "root_de478240";
export var svg = "svg_de478240";